import App from '../../App'
import {html, render } from 'lit-html'
import {gotoRoute, anchorRoute} from '../../Router'
import Auth from '../../Auth'
import Utils from '../../Utils'
import ProviderAPI from '../../ProviderAPI'
import Toast from '../../Toast'

class activeJobsView {
  init(){
    document.title = 'Active Jobs'    
    this.provider = null
    this.render()    
    Utils.pageIntroAnim()
    this.getProviders()
  }

  
  async getProviders(){
    try{
      this.provider = await ProviderAPI.getProviders()
      console.log(this.provider)
      this.render()
    }catch(err){
      Toast(err, 'error')
    }
  }

  activeJobs(){
    //create sl-dialog
    const dialogEl= document.createElement('sl-dialog')
    //add a className
    dialogEl.className ='provider-dialog'
    //sl-dialog content
    const dialogContent = html`

    <style>


    .profile-content-container{
      width: 90%;
     
    }


    .profile-content-info{
      text-align: left;
    }

    sl-dialog{
      --width: 50%;
     
    }

    sl-dialog::part(body){
      height: 450px;
     
    }

    .project{
      margin-left: 60%;
    }
        
    /*-----------RESPONSIVE-----------------*/
    @media all and (max-width: 1024px){       
        
      sl-dialog{
        --width: 70%;
       
      }
  
  
      
    }
      
    
    
    </style>


    <div class="activejobs">

          <div id="profile-content">

                  

          <div class="profile-content-container">

              <div class="profile-content-titles">
                <p >Client Name</p>
                <p> Phone Number</p>
                <p> Email</p>
                <p>Address</p>  
                <p class="active-title">Client Budget</p>
                <p class="active-title">Client Problems</p>
              
            </div>


                <div class="profile-content-info">
                      <p >${Auth.currentUser.firstName} ${Auth.currentUser.lastName} </p>
                      <p> ${Auth.currentUser.phone}</p>
                      <p>${Auth.currentUser.email}</p>
                      <p>${Auth.currentUser.address}</p>
                      <p class="active-subtitle">Rs 10,000 </p>  
                      
                      <p class="active-subtitle">Install new pipes and create drainage system, the project will consist of removal of old pipes and renovations, for more details please contact me on phone or email.  </p>   

                      
                      
                      
              </div>

        </div>


        </div>

        <div class="hiredbox"  >
      
      
      
      </div>

      





    <sl-button class="project"  href="/"  type="primary" >COMPLETE PROJECT</sl-button>

    
    `

    render(dialogContent,dialogEl)

    //append to body
    document.body.append(dialogEl)

    //show dialog
    dialogEl.show()



    //on hide delete dialog
    dialogEl.addEventListener('sl-after-hide', ()=> dialogEl.remove())

  }


  render(){
    const template = html`
      <va-app-header-blk  title="Services" user="${JSON.stringify(Auth.currentUser)}"></va-app-header-blk>

    <main id="hiredworkers">


    <div class="hired">
      <h1 class="hiredtitle"> Active Jobs<h1>
      <div id="hiredbox" class="animate__animated animate__fadeInLeft"  @click=${this.activeJobs.bind(this)} >
      <p class="active-title">Install new pipes and create drainage system for Jean Francois</p>
      <p class="active-subtitle">Project begun on 20th June  </p>   
      
      
      </div>

    </div>
            
        

            
       <main>


    `
    render(template, App.rootEl)
  }
}


export default new activeJobsView()